import { Box, Stack, Switch } from '@mui/material'
import {
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid-premium'

interface Props {
  loadsCombined: boolean
  onLoadsCombinedChange?: (value: boolean) => void
}

const LoadCustomToolbar = ({ loadsCombined, onLoadsCombinedChange }: Props) => {
  return (
    <GridToolbarContainer>
      <Stack direction="row" spacing={2} sx={{ width: '100%', alignItems: 'center' }}>
        <GridToolbarFilterButton slotProps={{ button: { size: 'small' } }} />
        <GridToolbarQuickFilter />

        {onLoadsCombinedChange ? (
          <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
            <Switch
              size="small"
              checked={loadsCombined}
              onChange={e => onLoadsCombinedChange(e.target.checked)}
            />
            <Box component="span" sx={{ fontSize: 12 }}>
              Lasten zusammenfassen
            </Box>
          </Box>
        ) : null}
      </Stack>
    </GridToolbarContainer>
  )
}

export default LoadCustomToolbar
